(function($) {
"use strict"

var defaults = {
    zIndex:1000,
    previewImages:true,
    showFileName:false,
    height:'81px',
    width:'81px',
    allowRemove:true
};

$.inputFileZone = function(elem, options){

    var plugin = this;

    plugin.options = options;
    plugin.input = $(elem);
    plugin.closestDiv = null;
    plugin.spanEl = null;
    plugin.browser = null;

    plugin.init = function(){
        plugin.start();
    };

    plugin.start = function(){
        StylingDropZone();
        EventsDropZone();
    };

    function toDataUrl(url, callback){
        if(!url) return false;

        var xhr = new XMLHttpRequest();
        xhr.onload = function(){
            var reader = new FileReader();
            reader.onloadend = function(){
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType='blob';
        xhr.send();
    }

    function StylingDropZone(){

        plugin.input.wrap('<div class="closest-dropzone"></div>');

        var input_name = plugin.input.attr('name');
        plugin.input.removeAttr('name');

        plugin.closestDiv = plugin.input.closest('.closest-dropzone');

        plugin.removeUrl = $(plugin.input).data('remove-url');
        plugin.removeData = $(plugin.input).data('remove-data');

        plugin.closestDiv.append(`
            <div class="dz-progressbar"><div class="dz-progress"></div></div>
            <input name="${input_name}" type="hidden" class="dz_file_data">
        `);

        if(plugin.options.allowRemove && plugin.removeUrl){
            plugin.closestDiv.append('<button type="button" class="dz-remove-btn">&times;</button>');
        }

        toDataUrl($(plugin.input).attr('src'),function(myBase64){
            plugin.closestDiv.css({
                'background-image':'url('+myBase64+')'
            });
        });

        if($(plugin.input).data('width')){
            plugin.options.width=$(plugin.input).data('width')
        }

        if($(plugin.input).data('height')){
            plugin.options.height=$(plugin.input).data('height')
        }

        plugin.closestDiv.css({
            width:plugin.options.width,
            height:plugin.options.height,
            position:'relative'
        });

        plugin.input.css({
            'z-index':plugin.options.zIndex+1,
            top:0,
            left:0,
            cursor:'pointer',
            height:'100%',
            width:'100%',
            position:'absolute',
            opacity:0
        });

        plugin.spanEl = plugin.closestDiv.find('span');
    }

    function EventsDropZone(){

        plugin.input.on({
            dragover:dragOver,
            dragenter:dragEnter,
            dragleave:dragExit,
            dragexit:dragExit
        });

        plugin.closestDiv.find('.dz-remove-btn').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            removeImage();
        });

        Browser();

        if(plugin.browser.msie && parseInt(plugin.browser.version,10) < 10){

            plugin.input.on({ drop:drop });

        }else{

            plugin.input.on({
                change:dropOrChange,
                drop:dropOrChange
            });

        }

    }

    function validate_file(file){

        if(plugin.options.file_types_allowed){
            if(plugin.options.file_types_allowed.indexOf(file.type) == -1){

                Swal.fire({
                    title:'Invalid File type',
                    icon:'warning'
                });

                return false;
            }
        }

        if(plugin.options.max_file_size){
            if(file.size > plugin.options.max_file_size){

                Swal.fire({
                    title:'Maximum File Size Limit Exceeded',
                    icon:'warning'
                });

                return false;
            }
        }

        return true;
    }

    function removeImage(){

        Swal.fire({
            title: 'Remove image?',
            text: 'This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, remove it'
        }).then(function(result){
            if(!result.isConfirmed) return;

            var data = {};

            if(plugin.removeData){
                try {
                    data = JSON.parse(plugin.removeData);
                } catch(e) {
                    data = plugin.removeData;
                }
            }

            var _token = plugin.input.attr('_token');
            if(typeof _token !== 'undefined'){
                data._token = _token;
            }

            plugin.closestDiv.append('<div class="dz-loading"></div>');

            $.ajax({
                url: plugin.removeUrl,
                type: 'POST',
                data: data,
                success: function(){
                    plugin.closestDiv.find('.dz-loading').remove();
                    plugin.closestDiv
                        .removeClass('upload-success upload-error dropzone-upload')
                        .css('background-image', 'none');
                    plugin.closestDiv.find('.dz_file_data').val('');
                    plugin.closestDiv.find('.dz-progress').css({width:'0%'});
                },
                error: function(){
                    plugin.closestDiv.find('.dz-loading').remove();
                    Swal.fire({
                        title:'Remove failed',
                        text:'Please try again',
                        icon:'error'
                    });
                }
            });
        });
    }

    function start_upload(file){

        var form_data = new FormData();

        var _token = plugin.input.attr('_token');

        if(typeof _token !== 'undefined'){
            form_data.append('_token',_token);
        }

        form_data.append('file',file);

        plugin.closestDiv.append('<div class="dz-loading"></div>');

        plugin.closestDiv.find('.dz-progress').css({
            width:0,
            background:'#4c6fff'
        });

        $.ajax({

            url:plugin.options.upload_url,
            data:form_data,
            processData:false,
            contentType:false,
            type:'POST',
            mimeType:"multipart/form-data",
            cache: false,

            xhr:function(){

                var xhr = new window.XMLHttpRequest();

                xhr.upload.addEventListener("progress",function(evt){

                    if(evt.lengthComputable){

                        var percent = evt.loaded / evt.total;

                        plugin.closestDiv.find('.dz-progress').css({
                            width:Math.round(percent*100)+"%"
                        });

                    }

                },false);

                return xhr;
            },

            success:function(response){

                plugin.closestDiv.find('.dz-loading').remove();

                plugin.closestDiv
                    .removeClass('dropzone-upload upload-error')
                    .addClass('upload-success');
                // Convert to string if it's an object
                var dataStr = (typeof response === 'object') ? JSON.stringify(response) : response;
                plugin.closestDiv.find('.dz_file_data').val(dataStr);

                plugin.closestDiv.find('.dz-progress').css({
                    width:'100%',
                    background:'#32c48d'
                });

            },

            error:function(){

                plugin.closestDiv.find('.dz-loading').remove();

                plugin.closestDiv
                    .removeClass('dropzone-upload')
                    .addClass('upload-error');

                plugin.closestDiv.find('.dz-progress').css({
                    width:'100%',
                    background:'#ff5b5b'
                });

                Swal.fire({
                    title:'Upload failed',
                    text:'Please try again',
                    icon:'error'
                });

            }

        });

    }

    function dropOrChange(event){

        killHandler(event);

        plugin.closestDiv.removeClass('upload-success upload-error');

        var file = event.target.files[0];

        if(!file){
            file = event.originalEvent.dataTransfer.files[0];
        }

        if(validate_file(file)){

            if(plugin.options.showFileName){

                plugin.closestDiv.addClass('dropzone-upload')
                .find('span')
                .text(file.name);

            }else{

                plugin.closestDiv.addClass('dropzone-upload')
                .find('span')
                .text('');

            }

            start_upload(file);

            if(plugin.options.previewImages){

                if(file.type.match('image.*')){

                    var reader = new FileReader();

                    reader.onload=function(event){

                        plugin.closestDiv.css({
                            'background-image':'url('+event.target.result+')'
                        });

                    };

                    reader.readAsDataURL(file);

                }

            }

        }

    }

    function drop(event){
        killHandler(event);
    }

    function dragEnter(event){
        killHandler(event);
    }

    function dragOver(event){

        killHandler(event);

        plugin.closestDiv.addClass('dropzone-upload');

    }

    function dragExit(event){

        killHandler(event);

        plugin.closestDiv.removeClass('dropzone-upload');

    }

    function killHandler(event){
        event.stopPropagation();
        event.preventDefault();
    }

    function Browser(){

        var browser = {
            msie:false,
            version:0
        };

        if(navigator.userAgent.match(/MSIE ([0-9]+)\./)){
            browser.msie=true;
            browser.version=RegExp.$1;
        }

        plugin.browser = browser;
    }

    plugin.init();

};

$.fn.extend({

    inputFileZone:function(options){

        if(options && typeof(options)=='object'){
            options = $.extend({},defaults,options);
        }

        if(!options) options = defaults;

        this.each(function(){
            new $.inputFileZone(this,options);
        });

        return;

    }

});

})(jQuery);
